const Verified = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46 23.98L41.12 18.4L41.8 11.02L34.58 9.38L30.8 3L24 5.92L17.2 3L13.42 9.38L6.2 11L6.88 18.4L2 23.98L6.88 29.56L6.2 36.96L13.42 38.6L17.2 45L24 42.06L30.8 44.98L34.58 38.6L41.8 36.96L41.12 29.58L46 23.98ZM38.1 26.94L36.98 28.24L37.14 29.94L37.5 33.84L33.7 34.7L32.02 35.08L31.14 36.56L29.16 39.92L25.6 38.38L24 37.7L22.42 38.38L18.86 39.92L16.88 36.58L16 35.1L14.32 34.72L10.52 33.86L10.88 29.94L11.04 28.24L9.92 26.94L7.34 24L9.92 21.04L11.04 19.74L10.86 18.02L10.5 14.14L14.3 13.28L15.98 12.9L16.86 11.42L18.84 8.06L22.4 9.6L24 10.28L25.58 9.6L29.14 8.06L31.12 11.42L32 12.9L33.68 13.28L37.48 14.14L37.12 18.04L36.96 19.74L38.08 21.04L40.66 23.98L38.1 26.94Z"
        fill="#7CD1B8"
      />
      <path
        d="M20.1801 27.5L15.5401 22.84L12.5801 25.82L20.1801 33.44L34.8601 18.72L31.9001 15.74L20.1801 27.5Z"
        fill="#7CD1B8"
      />
    </svg>
  );
};

export default Verified;
